/** Panel dropdown / popover — shadcn benzeri açık tema (topbar + liste menüleri) */

import { PANEL } from "./panelTokens";

export const panelDropdownTriggerSx = {
  width: 40,
  height: 40,
  minWidth: 40,
  minHeight: 40,
  maxWidth: 40,
  maxHeight: 40,
  p: 0,
  flexShrink: 0,
  boxSizing: "border-box",
  borderRadius: "50%",
  border: `1px solid ${PANEL.border}`,
  backgroundColor: PANEL.surface,
  color: PANEL.text.muted,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease",
  "&:hover": {
    borderColor: PANEL.accent.softBorder45,
    backgroundColor: PANEL.accent.soft12,
    color: PANEL.accent.text,
    boxShadow: PANEL.shadow.card,
  },
  "& .MuiBadge-root": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

/** Topbar tetikleyici içindeki ikon — outline, sabit boyut */
export const panelTopbarActionIconSx = {
  fontSize: 20,
  color: "inherit",
  display: "block",
};

export const panelDropdownPaperSx = {
  mt: 1,
  borderRadius: "12px",
  overflow: "hidden",
  backgroundColor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  boxShadow: "0 12px 32px rgba(15, 23, 42, 0.12), 0 2px 8px rgba(15, 23, 42, 0.06)",
};

export const panelDropdownPaperProps = (width = 384) => ({
  elevation: 0,
  sx: {
    ...panelDropdownPaperSx,
    width: { xs: `min(92vw, ${width}px)`, sm: width },
  },
});

export const panelDropdownPopoverSlotProps = (width = 384) => ({
  paper: panelDropdownPaperProps(width),
});

/** Popover — görünmez backdrop ile dış tıklamada kapanır (hideBackdrop kullanmayın) */
export const panelDropdownPopoverModalProps = {
  disableScrollLock: true,
  BackdropProps: {
    invisible: true,
  },
};

export const panelDropdownHeaderSx = {
  px: 2,
  py: 1.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  borderBottom: `1px solid ${PANEL.border}`,
  backgroundColor: PANEL.surface,
};

export const panelDropdownHeaderTitleSx = {
  fontWeight: 700,
  color: PANEL.text.primary,
  lineHeight: 1.2,
  fontSize: "0.95rem",
};

export const panelDropdownHeaderMetaSx = {
  color: PANEL.accent.text,
  fontWeight: 600,
  fontSize: "0.75rem",
};

export const panelDropdownHeaderActionSx = {
  color: PANEL.text.muted,
  border: `1px solid ${PANEL.border}`,
  borderRadius: "8px",
  p: 0.75,
  "&:hover": {
    backgroundColor: PANEL.pageBg,
    color: PANEL.text.primary,
    borderColor: PANEL.fill.hover,
  },
};

export const panelDropdownListSx = {
  maxHeight: 400,
  overflowY: "auto",
};

export const panelDropdownItemRowSx = (unread = false) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 0.5,
  backgroundColor: unread ? PANEL.accent.soft : "transparent",
  borderLeft: unread ? `3px solid ${PANEL.accent.main}` : "3px solid transparent",
  transition: "background-color 0.15s ease",
  "&:hover": {
    backgroundColor: PANEL.pageBg,
  },
});

export const panelDropdownItemButtonSx = {
  flex: 1,
  minWidth: 0,
  display: "flex",
  gap: 1.5,
  px: 2,
  py: 1.5,
  pr: 0.5,
  textAlign: "left",
  border: "none",
  cursor: "pointer",
  backgroundColor: "transparent",
  color: "inherit",
};

export const panelDropdownItemIconWrapSx = (accent = PANEL.accent.main) => ({
  mt: 0.25,
  width: 36,
  height: 36,
  borderRadius: "10px",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${accent}14`,
  color: accent,
  border: `1px solid ${accent}22`,
});

export const panelDropdownItemTitleSx = (unread = false) => ({
  fontWeight: unread ? 700 : 600,
  color: PANEL.text.primary,
  lineHeight: 1.35,
  mb: 0.35,
  fontSize: "0.875rem",
});

export const panelDropdownItemBodySx = {
  color: PANEL.text.muted,
  display: "block",
  lineHeight: 1.45,
  wordBreak: "break-word",
  fontSize: "0.8125rem",
};

export const panelDropdownItemTimeSx = {
  color: PANEL.text.label,
  mt: 0.5,
  display: "block",
  fontSize: "0.72rem",
  fontWeight: 500,
};

export const panelDropdownDividerSx = {
  borderColor: PANEL.border,
  mx: 2,
};

export const panelDropdownEmptySx = {
  textAlign: "center",
  px: 3,
  py: 5,
};

export const panelDropdownEmptyIconSx = {
  fontSize: 44,
  color: PANEL.text.label,
  mb: 1.5,
  opacity: 0.85,
};

export const panelDropdownEmptyTitleSx = {
  fontWeight: 600,
  color: PANEL.text.primary,
  mb: 0.75,
  lineHeight: 1.4,
  fontSize: "0.875rem",
};

export const panelDropdownEmptyHintSx = {
  color: PANEL.text.muted,
  lineHeight: 1.55,
  display: "block",
  fontSize: "0.8125rem",
};

export const panelDropdownFooterSx = {
  px: 2,
  py: 1,
  display: "flex",
  justifyContent: "space-between",
  borderTop: `1px solid ${PANEL.border}`,
  backgroundColor: PANEL.fill.muted,
};

export const panelDropdownFooterButtonSx = {
  fontSize: "0.72rem",
  textTransform: "none",
  fontWeight: 600,
  color: PANEL.accent.text,
  "&:hover": { backgroundColor: PANEL.accent.soft },
};

export const panelDropdownBadgeSx = {
  "& .MuiBadge-badge": {
    fontWeight: 700,
    fontSize: "0.65rem",
    minWidth: 18,
    height: 18,
    backgroundColor: PANEL.danger.main,
    color: "#fff",
    boxShadow: "0 0 0 2px #fff",
  },
};

export const panelDropdownUnreadDotSx = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  bgcolor: PANEL.accent.main,
  flexShrink: 0,
  mt: 0.75,
};

export const panelDropdownMenuItemSx = (selected = false) => ({
  justifyContent: "flex-start",
  gap: 1.25,
  px: 1.25,
  py: 1.1,
  borderRadius: "10px",
  textTransform: "none",
  color: PANEL.text.primary,
  background: selected ? PANEL.accent.soft : "transparent",
  border: selected ? `1px solid ${PANEL.accent.softBorder}` : "1px solid transparent",
  transition: "all 0.15s ease",
  "&:hover": {
    background: PANEL.pageBg,
  },
});

export const panelDropdownMenuItemBadgeSx = (selected = false) => ({
  width: 32,
  height: 32,
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  fontSize: "0.7rem",
  fontWeight: 800,
  letterSpacing: "0.04em",
  color: selected ? PANEL.accent.text : PANEL.text.muted,
  background: selected ? PANEL.accent.soft : PANEL.fill.muted,
  border: `1px solid ${selected ? PANEL.accent.softBorder : PANEL.border}`,
});
